import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=15ad678c&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=15ad678c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad678c",
  null
  
)

export default component.exports